// sentinel parentId the projects space uses for its top level - there is no project above it
export const MENU_PROJECTS_TREE_ROOT_ID = 'root'
